module.exports = __webpack_public_path__ + "js/stellarium-web-engine.b06451fb.wasm";